import React, { type ReactNode, useContext } from 'react'

import styles from './index.module.css'
import { CardContext } from '..'

interface IDetailsProps {
  children: ReactNode
  hide?: boolean
}

export const Details = (props: IDetailsProps) => {
  const { children, hide } = props

  const { variant } = useContext(CardContext)

  if (hide) return null

  return (
    <div className={styles.container} data-variant={variant}>
      {children}
    </div>
  )
}

Details.displayName = 'Card.Details'
